import React from "react";
import { CashierBrandLogo } from "./CashierBrandLogo";
import { buildCashierVisualStyle } from "./cashierVisualStyle";
import "./CashierStyle.css";

export interface CashierErrorViewProps {
  /** 商户回跳地址，优先于 referrer */
  returnUrl?: string;
  title?: string;
  description?: string;
}

const PAY_SUPPORT_HINT = "如遇到支付问题，请联系空间助理进行企业微信邀约付款。";

const resolveMerchantReturnUrl = (returnUrl?: string): string => {
  const fromParam = returnUrl?.trim();
  if (fromParam) {
    return fromParam;
  }
  const referrer = typeof document !== "undefined" ? document.referrer.trim() : "";
  return referrer;
};

export const CashierErrorView: React.FC<CashierErrorViewProps> = ({
  returnUrl,
  title = "请稍后",
  description = "收银台暂时无法打开，请返回商户页面重试",
}) => {
  const merchantUrl = resolveMerchantReturnUrl(returnUrl);

  const handleReturn = () => {
    if (merchantUrl) {
      window.location.href = merchantUrl;
      return;
    }
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.close();
  };

  return (
    <div className="cashier-shell cashier-status-page" style={buildCashierVisualStyle()}>
      <div className="cashier-status-card" role="alert">
        <header className="cashier-status-header">
          <CashierBrandLogo size={32} className="cashier-brand-logo" />
          <span className="cashier-status-brand">龙粉社收银台</span>
        </header>

        <div className="cashier-status-icon-wrap" aria-hidden>
          <svg className="cashier-status-icon" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" />
            <path
              d="M32 20v18"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <circle cx="32" cy="44" r="2" fill="currentColor" />
          </svg>
        </div>

        <h1 className="cashier-status-title">{title}</h1>
        <p className="cashier-status-desc">{description}</p>

        <button type="button" className="cashier-status-primary-btn" onClick={handleReturn}>
          返回商户
        </button>

        <p className="cashier-status-foot-hint">{PAY_SUPPORT_HINT}</p>
      </div>
    </div>
  );
};
